export default {
  tableData(array) {
    let result = [];
    for(let i=0; i<array.length; i++) {
      let item = array[i];

      let ordering = true;
      if(item[3]===false) ordering = false;
      result.push( {
        eng_name: item[0],
        ko_name: item[1],
        width: `${item[2]}px`,
        ordering: ordering
      })
    }

    return result;
  },

  options(array) {
    let result = [];

    for(let i=0; i<array.length; i++) {
      let item = array[i];
      result.push( {
        label: item[0],
        value: item[1]
      })
    }

    return result;
  }
}
